'use es6';

import { fontsLoaded as areFontsLoaded, fontsLoadedPromise, iconFontsLoaded as areIconFontsLoaded, iconFontsLoadedPromise } from 'UIComponents/utils/Fonts';
export default function debugFontsAndIconsLoaded() {
  const fontsLoaded = areFontsLoaded();
  const iconFontsLoaded = areIconFontsLoaded();
  console.warn('Checking font and icon loading status', JSON.stringify({
    fontsLoaded,
    iconFontsLoaded
  }, null, 2));
  if (!fontsLoaded) {
    fontsLoadedPromise.then(() => console.warn('fontsLoadedPromise resolved')).catch(e => console.warn('fontsLoadedPromise rejected', e));
  }
  if (!iconFontsLoaded) {
    iconFontsLoadedPromise.then(() => console.warn('iconFontsLoadedPromise resolved')).catch(e => console.warn('iconFontsLoadedPromise rejected', e));
  }
}